import React from "react";
import "./styles/color.css";
import "./styles/font.css";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/index.css";
import "./styles/tailwind.css";

// Defers every ResizeObserver callback to the next animation frame. This
// codebase uses several ResizeObserver-driven libraries on the same pages
// (ag-Grid's internal auto-sizing, react-select's dropdown positioning,
// react-modal, etc.) -- when two of them resize in the same frame (e.g.
// typing in a medicine search dropdown next to an ag-Grid table), the
// browser reports a harmless "ResizeObserver loop completed with
// undelivered notifications" error, which CRA's dev overlay surfaces
// prominently even though nothing actually breaks. Deferring callbacks by
// one frame prevents the loop condition from ever being detected, fixing
// this at the root rather than just hiding the dev-mode overlay.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
